import { Route, Switch } from 'react-router-dom';

import { PrivacyNotice, PrivacyPolicy, ParrotConnectPayTerms, LegalIndex } from 'domains/compliance';

/**
 * Rutas públicas para documentos legales
 * No requieren autenticación
 */
export const LegalRoutes = () => {
  return (
    <Switch>
      <Route component={LegalIndex} exact path="/legal" />
      {/* Serves the privacy notice: the terms document published here was superseded on 18 September 2026. */}
      <Route component={PrivacyNotice} exact path="/legal/terms" />
      <Route component={ParrotConnectPayTerms} exact path="/legal/terms-pay" />
      <Route component={PrivacyPolicy} exact path="/legal/privacy" />
    </Switch>
  );
};
